import { apiTypeHelper } from '@/base/network'

export const LIST_TRAINERS = apiTypeHelper('LIST_TRAINERS')
export const ADD_TRAINER = apiTypeHelper('ADD_TRAINER')
export const DELETE_TRAINER = apiTypeHelper('DELETE_TRAINER')
export const GET_TRAINER_PROFILE = apiTypeHelper('GET_TRAINER_PROFILE')
